import { useTranslation as rnUseTranslation } from 'react-i18next';

export const useTranslation = () =>
  rnUseTranslation('candidate-facing-components');
